import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Pagination } from "../../../../common/pagination";
import ModernPagination from "../../../../common/pagination/ModernPagination"; // Import new pagination
import Heading from '../../../../common/element/Heading';
import CoachesList from './Coaches';
import ClientInput from "../../../../common/element/Input/clientInput";
import BtnPrimary from "../../../../common/element/Buttons/btnPrimary";
import { debounce } from "../../../../common/snippet/Debouncing";
import { setBreadcrumbs } from "../../../../redux/Admin/breadcrumbsSlice";
import { useDispatch } from 'react-redux';
import AddEditCoach from './AddEdit';
import { getCoachList } from '../../../../redux/Coach/coachSlice';
import { useSelector } from 'react-redux';
import { selectCoachListLoading, selectCoachListTotal } from '../../../../redux/Coach/coachSelector';

const Coaches = () => {
  const totalRecords = useSelector(selectCoachListTotal);
  const coachLoading = useSelector(selectCoachListLoading);

  const [countData, setCountData] = useState(0);
  const [filterpage, setfilterpage] = useState(1);
  const [filterlimit, setfilterlimit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const dispatch = useDispatch();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [getFilterData, SetFilterData] = useState({
    function_assignment_id: "",
    page: 1,
    limit: 10,
    sort: "created_date",
    order: "desc",
    search: "",
  });

  // Search Data
  const handleSearch = (e) => {
    SetFilterData((prevalue) => {
      return {
        ...prevalue,
        [e.target.name]: e.target.value.trim(),
      };
    });
  };

  useEffect(() => {
    dispatch(
      setBreadcrumbs([
        {
          label: "Coaches",
          url: "/coaches",
          home: "/companies",
        },
        
      ])
    );
  }, []);

  const inputchangehandler = useCallback(debounce(handleSearch), [handleSearch]);

  // use Redux store data for coaches
  const coachList = useSelector((state) => state.coach.getCoachList.data || []);
  const coachListLoading = useSelector((state) => state.coach.getCoachList.loading);

  const allInvoicesData = coachList;
useEffect(() => {
  // Prefer totalRecords from Redux (if valid)
  const total = typeof totalRecords === 'number' && totalRecords > 0
    ? totalRecords
    : coachList?.length || 0;

  setCountData(total);

  // Calculate totalPages based on current filterlimit
  const pages = Math.max(1, Math.ceil(total / filterlimit));
  setTotalPages(pages);
}, [totalRecords, coachList, filterlimit]);


  const handlePageChange = (page) => {
    setfilterpage(page);
  };

  // Use server-side search: don't filter on the client. Just pass the coachList through.
  const filteredData = coachList;
useEffect(() => {
  dispatch(getCoachList({
    page: filterpage,
    limit: filterlimit,
    search: getFilterData.search
  }));
}, [dispatch, filterpage, filterlimit, getFilterData.search]);


  return (
    <React.Fragment>
      <div>
        <p className="text-gray-600 my-3">
          {/* Non morbi vitae turpis leo scelerisque nisl phasellus nisi. Commodo. */}
        </p>
      </div>

      <div className="flex justify-between mb-5">
        <div className="w-80 h-10 text-start">
          <Heading>All Coaches</Heading>
        </div>

        <div className="flex gap-2">
          <BtnPrimary
            onClick={() => setDialogOpen(true)}
            className="text-xs h-9 flex items-center justify-center px-3 gap-1"
          >
            Add Coach
            <svg
              width="21"
              height="20"
              viewBox="0 0 21 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.712 4.167v11.666M4.878 10h11.667"
                stroke="#fff"
                strokeWidth="1.667"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </BtnPrimary>
        </div>
      </div>

      <div className="flex justify-end mb-4">
        <div className="input-wrapper">
          <div className="input-suffix-start left-3.5">
            <img
              src="/assets/icons-svg/search-lg.svg"
              alt=""
              className="h-5"
            />
          </div>
          <ClientInput
            type="text"
            className="input pl-10 w-80 input-shadow h-10 text-sm border-gray-300 rounded-lg appearance-none border text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            placeholder="Search"
            inputchangehandler={inputchangehandler}
            name={"search"}
          />
        </div>
      </div>

  <CoachesList sampleData={filteredData} currentPage={filterpage}
        pageLimit={filterlimit}  loading={coachLoading}/>

      <AddEditCoach
        dialogOpen={dialogOpen}
        onDialogClose={() => setDialogOpen(false)}
        onSuccess={() => {
          // Refresh coach list after successful add/update
          dispatch(getCoachList({ page: filterpage, limit: filterlimit, search: getFilterData.search }));
        }}
      />

      <div className="flex justify-between items-center mt-3">
        {/* Left side - Pagination info */}
        <Pagination
          totalCount={countData}
          pageNumber={filterpage}
          displayPage={allInvoicesData?.length}
          UpdatePageLimit={setfilterlimit}
          UpdatePage={setfilterpage}
        />

        {/* Right side - Modern Pagination Controls */}
        {countData > 0 && totalPages > 1 && (
          <ModernPagination
            totalPages={totalPages}
            currentPage={filterpage}
            onPageChange={handlePageChange}
          />
        )}
      </div>
    </React.Fragment>
  )
}

export default Coaches